var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImgAllIncorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4ZM15.665 8.33398C15.2188 7.88825 14.495 7.88811 14.0488 8.33398L11.999 10.3828L9.95117 8.33398C9.50484 7.88795 8.7802 7.88776 8.33398 8.33398C7.88776 8.7802 7.88795 9.50484 8.33398 9.95117L10.3828 11.999L8.33398 14.0488C7.88811 14.495 7.88825 15.2188 8.33398 15.665C8.7803 16.1114 9.50486 16.1114 9.95117 15.665L11.999 13.6162L14.0488 15.665C14.4951 16.1113 15.2187 16.1113 15.665 15.665C16.1113 15.2187 16.1113 14.4951 15.665 14.0488L13.6162 11.999L15.665 9.95117C16.1114 9.50486 16.1114 8.7803 15.665 8.33398Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImgAllIncorrect);
export default __webpack_public_path__ + "static/media/iconImgAllIncorrect.90f01b202773ebd126a6dff8c0cac4df.svg";
export { ForwardRef as ReactComponent };